import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Observable } from 'rxjs';
import { AppConfig } from '../../app.config';

import { UserService } from '../../core/services/user.service';
import { GameElement } from '../models/game-element.model';

import { GameSelection } from '../models/game-selection.model';
import { Status } from '../models/status.model';

import { MessageModalComponent } from '../../core/components/message-modal/message-modal.component';
import { GameSelectionCreateModalComponent } from '../components/modals/game-selection-create-modal/game-selection-create-modal.component';
import { GameSelectionListModalComponent } from '../components/modals/game-selection-list-modal/game-selection-list-modal.component';

import { ApiBaseService } from '../../core/services/api-base.service';
import Utils from '../utils/utils';
import { FileService } from './file.service';

import { CreateOptions } from '../interfaces/create-options.interface';
import { ModelMapperService } from './mapper/model-mapper.service';

@Injectable()
export class GameSelectionService extends ApiBaseService<GameSelection> {

  constructor(
    protected http: HttpClient,
    protected router: Router,
    protected userService: UserService,
    protected fileService: FileService,
    protected modalService: NgbModal,
    private modelMapper: ModelMapperService
  ) {
    super(GameSelection, 'selections', http, router, userService, fileService);

    this.url = AppConfig.GAME_SERVER + AppConfig.GAME_BASE_URL;
  }

  select(exclude: GameSelection[] = [], selectionTypes?: number[]): Promise<GameSelection[]> {
    const modalRef = this.modalService.open(GameSelectionListModalComponent, {size: 'lg'});
    modalRef.componentInstance.status = new Status();

    this.getAll(modalRef.componentInstance.status)
      .subscribe((selections: GameSelection[]) => {
        try {
          modalRef.componentInstance.selections = selections
            .filter(selection => exclude.findIndex(mySelection => selection.id === mySelection.id) < 0);

          if (selectionTypes && selectionTypes.length > 0) {
            modalRef.componentInstance.selectionTypes = selectionTypes;
          }
        } catch (e) {
        }
      });

    return modalRef.result;
  }

  create(options: CreateOptions<GameSelection>, selectionTypes?: number[], gameTypes?: number[]): Promise<GameSelection> {
    return super.create(Object.assign(options, {
      component: GameSelectionCreateModalComponent,
      componentOptions: {
        selection: this.emptyModel(),
        selectionTypes,
        gameTypes
      }
    }));
  }

  getElements(selectionId: string, status?: Status): Observable<GameElement[]> {
    status = status || new Status();
    status.setLoading();

    const url = `${this.url}/${selectionId}/elements`;
    const responseKey = '_embedded.elements';

    return this.http
      .get(url).pipe(
        map(response => {
          if (Utils.deepAccessUsingString(response, responseKey) && Utils.deepAccessUsingString(response, responseKey).length > 0) {
            status.setSuccess();
            return Utils.deepAccessUsingString(response, responseKey)
              .filter(object => this.modelMapper.gameElementCheckJSON(object))
              .map(object => this.modelMapper.gameElementFromJSON(object));
          } else {
            status.setNoResults();
          }
        }),
        catchError(err => this.handleError(err, status)));
  }

  delete(id: string, status?: Status): Promise<any> {
    const modalRef = this.modalService.open(MessageModalComponent);
    modalRef.componentInstance.confirm = true;
    modalRef.componentInstance.message = 'Are you sure that you want to delete the selection?';

    return modalRef.result.then(() => super.delete(id, status), () => Promise.reject('Dimissed'));
  }

  checkJSON(json: any): boolean {
    return this.modelMapper.selectionCheckJSON(json);
  }

  emptyModel(): GameSelection {
    return this.modelMapper.selectionEmptyModel();
  }

  fromJSON(json: any, skipCheck?: boolean): GameSelection {
    return this.modelMapper.selectionFromJSON(json, skipCheck);
  }
}
